// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreeColumnsCards {
    flex-direction: column;
    align-items: flex-start;
}

.ThreeColumnsCards-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    padding-top: 100px;
    padding-bottom: 60px;
}

.LargeCard {
    border-radius: 32px;
}

.SmallCard {
    border-radius: 32px;
    height: 300px;
    padding: 48px;
    margin: 0 10px;
}

.SmallCard .ant-card-body {
    padding: 0px;
    width: -webkit-fill-available;
}

/* .SmallCard img {
    @media screen and (max-width: 1024px) and (min-width: 1024px) {
        width: 100%;
    }
} */

.LargeCard-title {
    margin: 20px 0;
    height: 80px;
}

@media screen and (max-width: 1024px) {
    
    .SmallCard, .LargeCard {
        border-radius: 16px;
        margin: 0 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/ThreeColumnsCards.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;;;;GAIG;;AAEH;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI;QACI,mBAAmB;QACnB,cAAc;IAClB;AACJ","sourcesContent":[".ThreeColumnsCards {\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.ThreeColumnsCards-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n    padding-top: 100px;\n    padding-bottom: 60px;\n}\n\n.LargeCard {\n    border-radius: 32px;\n}\n\n.SmallCard {\n    border-radius: 32px;\n    height: 300px;\n    padding: 48px;\n    margin: 0 10px;\n}\n\n.SmallCard .ant-card-body {\n    padding: 0px;\n    width: -webkit-fill-available;\n}\n\n/* .SmallCard img {\n    @media screen and (max-width: 1024px) and (min-width: 1024px) {\n        width: 100%;\n    }\n} */\n\n.LargeCard-title {\n    margin: 20px 0;\n    height: 80px;\n}\n\n@media screen and (max-width: 1024px) {\n    \n    .SmallCard, .LargeCard {\n        border-radius: 16px;\n        margin: 0 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
